import Matic from './Matic';

export default Matic;
